export function BrandLogo({ compact = false }: { compact?: boolean }) {
  return (
    <img
      className={compact ? "brand-logo compact" : "brand-logo"}
      src={compact ? "/brand/mundely_backpack_icon.png" : "/brand/mundely_logo_home.png"}
      alt="Mundely"
    />
  );
}
